import React, { useEffect, useState } from 'react'
import { Paper } from '@mui/material';
import { Button } from '@mui/material';
import PublicationTable from '../table/viewPublications';
import FormDialog from '../panel/modal';
import AddPublication from '../form/addPublication';
import { useNavigate } from 'react-router-dom';
import api from '../../API/api';
import { useLocation } from 'react-router-dom';

function Publication() {
    const navigation = useNavigate();
    const location = useLocation();
    // console.log(location.state.facultyId,'facultyId');
    const [open, setOpen] = useState();
    const [modalData, setModalData] = React.useState();
    const [pubs, setPubs] = useState();
    const [facultyId, setFacultyId] = useState(location.state?.facultyId)

    const handleClickOpen = (data) => {
        setOpen(true);
        setModalData(data);
    };
    const handleClose = () => {
        setOpen(false);
    };

    function getPublications() {
        api.getPublications().then(res => {
            // console.log(res.data.publication, 'check getPublications');
            setPubs(res.data.publication)
        }).catch(err => {
            // console.log(err, 'check err');
        })
    }

    useEffect(() => {
        getPublications();
    }, [])



    return (

        <div className='row'>
            <Paper elevation={3}>
                <div className="col-12 d-flex justify-content-between p-3">
                    <h4>Publications</h4>
                    <Button variant='contained' onClick={handleClickOpen}>+Add Publications</Button>
                </div>

                <FormDialog form={<AddPublication handleClose={handleClose} handleClickOpen={handleClickOpen} modalData={modalData} facultyId={facultyId} />}
                    title='Add Publication' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} facultyId={facultyId} />

                <PublicationTable publication={pubs} handleClickOpen={handleClickOpen} />
            </Paper>
        </div>
    )
}

export default Publication;